import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetEnterpriseConnectionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetEnterpriseConnectionsQueryResult = { __typename?: 'Query' } & Pick<
  GraphQLTypes.Query,
  'enterpriseConnectionNames'
>;

export const GetEnterpriseConnectionsDocument = gql`
  query getEnterpriseConnections {
    enterpriseConnectionNames
  }
`;
